module.exports = __webpack_public_path__ + "static/media/shape_T.864158d2.glb";